/**
 * Function that adds delay to a function to keep it from being called too frequently.
 * @param {Function} func - function to be throttled
 * @param {number} delay
 * @param {boolean} leading - true if function should be applied before timeout
 * @returns {Function}
 * */
let isWaiting = false;
const throttle = (func, delay, leading = false) => {
  if (leading) {
    return (...args) => {
      if (!isWaiting) {
        func.apply(undefined, args);
        isWaiting = true;
        setTimeout(() => {
          isWaiting = false;
        }, delay);
      }
    };
  }
  let isInThrottle = null;
  return (...args) => {
    if (!isInThrottle) {
      isInThrottle = setTimeout(() => {
        func.apply(undefined, args);
        isInThrottle = null;
      }, delay);
    }
  };
};

export { throttle as t };
//# sourceMappingURL=throttle-B18Nc4CR.js.map
